/**
 * Campaign Invite Management Utilities
 * Handles adding and removing invited users from campaigns
 */

/**
 * Add an email to campaign's invited users
 * TODO: Implement with Appwrite database
 * @param campaignId - Campaign ID
 * @param email - Email address to invite
 * @returns Success status
 */
export const addInvitedUser = async (campaignId: string, email: string): Promise<{ success: boolean; message: string }> => {
  console.warn('addInvitedUser: Needs Appwrite migration');

  // Validate email format (keep validation)
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { success: false, message: 'Invalid email format' };
  }

  // Feature disabled during migration
  return {
    success: false,
    message: 'Campaign invites temporarily disabled during migration'
  };
};

/**
 * Remove an email from campaign's invited users
 * TODO: Implement with Appwrite database
 * @param campaignId - Campaign ID
 * @param email - Email address to remove
 * @returns Success status
 */
export const removeInvitedUser = async (campaignId: string, email: string): Promise<{ success: boolean; message: string }> => {
  console.warn('removeInvitedUser: Needs Appwrite migration');

  // Feature disabled during migration
  return {
    success: false,
    message: 'Campaign invites temporarily disabled during migration'
  };
};

/**
 * Get list of invited users for a campaign
 * TODO: Implement with Appwrite database
 * @param campaignId - Campaign ID
 * @returns Array of invited email addresses
 */
export const getInvitedUsers = async (campaignId: string): Promise<string[]> => {
  console.warn('getInvitedUsers: Needs Appwrite migration');
  return [];
};

/**
 * Check if current user can manage invites for a campaign
 * @param campaignData - Campaign metadata
 * @param userEmail - Current user's email
 * @returns True if user is owner or admin
 */
export const canManageInvites = (campaignData: any, userEmail: string | null | undefined): boolean => {
  if (!campaignData || !userEmail) return false;

  const normalizedEmail = userEmail.toLowerCase().trim();

  // Check if user is superadmin
  if (normalizedEmail === 'brainiac@brainiacsbots.com') return true;

  // Check if user is campaign owner
  if (campaignData.client_email === normalizedEmail) return true;

  return false;
};
